import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useSimpleRegion 创建Number上下文
 */
import { useRefCallback, useRefGetter, useSingleton } from '@tencent/glue-react-use';
import { useEffect, useState } from 'react';
import { AxisType, RangeRegion } from '@tencent/glue-model-region';
export function useRangeRegion(options, onChange) {
  var region = useSingleton(function () {
    return new RangeRegion();
  });
  var onChangeCallback = useRefCallback(onChange);

  var _useState = useState([0, 0]),
      _useState2 = _slicedToArray(_useState, 2),
      offset = _useState2[0],
      setOffset = _useState2[1];

  var offsetGetter = useRefGetter(offset);
  useEffect(function () {
    var repaint = function repaint() {
      var _region$getSelectedOf = region.getSelectedOffset(),
          _region$getSelectedOf2 = _slicedToArray(_region$getSelectedOf, 2),
          start = _region$getSelectedOf2[0],
          end = _region$getSelectedOf2[1];

      var of = offsetGetter();
      var len = region.getAxis(AxisType.HORIZONTAL).getAxisLength();

      if (start.x !== of[0] || len - end.x !== of[1]) {
        setOffset([start.x, len - end.x]);
      }
    };

    repaint();
    region.addListener('repaint', repaint);
    region.addListener('change', onChangeCallback);
    return function () {
      region.removeListener('repaint', repaint);
      region.removeListener('change', onChangeCallback);
    };
  }, []);
  region.updateOptions(options);
  return [region, offset];
}